'use client';
import { isBrowser } from '@s7/platform';

const getScrollStart = ({ axis, parent })=>{
    if (!parent && !isBrowser) {
        return 0;
    }
    const method = axis === 'y' ? 'scrollTop' : 'scrollLeft';
    if (parent) {
        return parent[method];
    }
    const { body, documentElement } = document;
    return body[method] + documentElement[method];
};

export { getScrollStart };
//# sourceMappingURL=getScrollStart.js.map
